import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fixed z-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_history_content = _resolveComponent("search-history-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex item-center justify-center", [_ctx.store.state.layout.searchHistory.open ? 'relative h-screen w-screen' : 'h-0 w-screen']])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["md:duration-500 absolute md:transition-all overflow-scroll bg-white", [_ctx.store.state.layout.searchHistory.open ? 'h-screen w-screen md:w-2/3 lg:w-1/2' : 'h-0 w-screen md:w-2/3 lg:w-1/2']])
        }, [
          _createVNode(_component_search_history_content)
        ], 2),
        _createVNode(_Transition, { name: "top" }, {
          default: _withCtx(() => [
            (_ctx.dimmer && _ctx.store.state.layout.searchHistory.open)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('layout/switchsearchHistoryOpen'),_ctx.store.dispatch('layout/pcSearchingOff'))),
                  class: "bg-neutral-700 bg-opacity-50 w-full"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}